export const selectedScenarioSelector: (state: RootState) => Scenario | undefined
    = (state: RootState) => state.scenarios.selected;
